export const CALCULATE_VISIBILITY_WITH_NOT_RELEVANT_CATEGORIES = "CALCULATE_VISIBILITY_WITH_NOT_RELEVANT_CATEGORIES";

export default function calculateVisibilityWithNotRelevantCategories(sortOrder, categoriesMap, notRelevantCategories) {
  return {
    type: CALCULATE_VISIBILITY_WITH_NOT_RELEVANT_CATEGORIES,
    payload: { notRelevantCategories, categoriesMap, sortOrder },
  };
}
